
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import ProgressPips from "@/components/journal/ProgressPips";
import { useSettings } from "@/context/SettingsContext";
import { cn } from "@/lib/utils";
import { getRpgThemeClasses } from "@/lib/utils";
import { DifficultyRank } from "@/utils/difficultyRanks";

interface JournalEntryProgressProps {
  progress: number;
  maxProgress: number;
  onCompleteProgress: () => Promise<boolean>;
  onPipClick: (pipValue: number) => Promise<boolean>;
  difficultyRank?: string | null; // Accept string from database
}

const JournalEntryProgress: React.FC<JournalEntryProgressProps> = ({
  progress,
  maxProgress,
  onCompleteProgress,
  onPipClick,
  difficultyRank
}) => {
  const { darkMode, enableRpgMode } = useSettings();
  const rpgTheme = getRpgThemeClasses(enableRpgMode, darkMode);

  // Cast string to DifficultyRank for the ProgressPips component
  const difficultyRankTyped = difficultyRank as DifficultyRank | null;

  return (
    <Card className={cn(
      "mb-6",
      enableRpgMode && rpgTheme.cardBackground + " shadow-xl"
    )}>
      <CardHeader>
        <CardTitle className={cn(
          enableRpgMode && rpgTheme.text
        )}>
          {enableRpgMode ? "Journey Milestones" : "Unstuck Tracker"}
        </CardTitle>
        <CardDescription className={cn(
          enableRpgMode && rpgTheme.accent
        )}>
          {enableRpgMode 
            ? "Mark your progress along the path to breakthrough"
            : "Track your progress toward getting unstuck"
          }
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ProgressPips 
          progress={progress}
          maxProgress={maxProgress}
          onCompleteProgress={onCompleteProgress}
          onPipClick={onPipClick}
          size="lg"
          difficultyRank={difficultyRankTyped}
        />
      </CardContent>
    </Card>
  );
};

export default JournalEntryProgress;
